import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Scroll on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  // Scroll when clicking same route
  useEffect(() => {
    const handleForceScroll = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    window.addEventListener("force-scroll-top", handleForceScroll);
    return () =>
      window.removeEventListener("force-scroll-top", handleForceScroll);
  }, []);

  return null;
};

export default ScrollToTop;
